import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const persistedState = ['analytics']
const gameLimit = 20 * 60 * 1000
const gameLimitRealTime = 2 * 12 * 30 * 24 * 60 * 60 * 1000

import control from './modules/control.js'
import balance from './modules/balance.js'
import regions from './modules/regions.js'
import goods from './modules/goods.js'
import history from './modules/history.js'
import rewards from './modules/rewards.js'
import actions from './modules/actions.js'
import progress from './modules/progress.js'
import enemy from './modules/enemy.js'
import guide from './modules/guide.js'
import analytics from '@/utils/analytics.js'

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: 'pikabu.ebay.store.v1.0',
            paths: persistedState
        })
    ],
    modules: {
        control,
        balance,
        regions,
        goods,
        history,
        rewards,
        actions,
        progress,
        enemy,
        guide
    },
    state: {
        game: 'run',
        links: {
            ebay: 'https://pikabu.ru/story/botromlovolu_imvidaloi_rok_m_sdey_nebraak_tam_5512520',
            pikabu: 'https://pikabu.ru/'
        }
    },
    getters: {
        date (state, getters, rootState) {
            const time = rootState.control.time
            const left = (gameLimitRealTime * time / gameLimit) / 1000
            const hours = Math.floor((left / (60 * 60)) % 24)
            const days = Math.ceil((left / (60 * 60 * 24)) % 30)
            const months = Math.floor((left / (60 * 60 * 24 * 30)) % 12)
            const years = Math.floor((left / (60 * 60 * 24 * 30 * 12)))
            return {hours, days, months, years}
        }
    },
    actions: {
        update ({rootState, dispatch, commit}) {
            if (rootState.progress.progress === 100) {
                dispatch('control/pause', null, {root: true})
                dispatch('history/push', {message: `WIN`}, {root: true})
                commit('game', 'win')
                analytics.getPixel('https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cvroc&pfb=hujgs&pr=%random%&ptrc=b')
            }
            else if (gameLimit < rootState.control.time || rootState.balance.balance < 0) {
                dispatch('control/pause', null, {root: true})
                dispatch('history/push', {message: `GAME OVER`}, {root: true})
                commit('game', 'lose')
                analytics.getPixel('https://ads.adfox.ru/260477/getCode?p1=ccqdp&p2=frfe&pfc=cvroc&pfb=hujgu&pr=%random%&ptrc=b')
            }
            else {
                dispatch('regions/update', null, {root: true})
                dispatch('progress/update', null, {root: true})
                dispatch('actions/update', null, {root: true})
                dispatch('enemy/update', null, {root: true})
            }
        },

        reset ({commit, dispatch}) {
            commit('reset')
            dispatch('control/reset', null, {root: true})
            dispatch('balance/reset', null, {root: true})
            dispatch('goods/reset', null, {root: true})
            dispatch('regions/reset', null, {root: true})
            dispatch('rewards/reset', null, {root: true})
            dispatch('history/reset', null, {root: true})
            dispatch('progress/reset', null, {root: true})
            dispatch('enemy/reset', null, {root: true})
            dispatch('guide/reset', null, {root: true})
        }
    },

    mutations: {
        game (state, value) {
            state.game = value
        },

        reset (state) {
            state.game = 'run'
        }
    }
})
